
<div class="form-horizontal">
  <div class="form-group">
    <label class="col-md-1 control-label">Código Solicitud:</label>
    <div class="col-md-1">
      <mat-form-field appearance="outline">
        <mat-label>Código Solicitud:</mat-label>
        <input
          matInput
          type="text"
          disabled="disabled"
          aria-label="Contratista"
          name="codigo"
          [value]="model.codigo"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-1 control-label">Compañía:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label> Compañía: </mat-label>
        <input matInput type="text" [(ngModel)]="model.compania" disabled />
      </mat-form-field>
    </div>
    <label class="col-md-1 control-label">Sede:</label>
    <div class="col-md-2">
      <mat-form-field appearance="outline">
        <input matInput type="text" [(ngModel)]="model.nombreSede" disabled />
      </mat-form-field>
    </div>
  </div>
    <div class="form-group">
      <label class="col-md-1 control-label">Empresa:</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Empresa:</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="model.contratista"
            disabled
          />
        </mat-form-field>
      </div>
      <label class="col-md-1 control-label">Fecha Inicio:</label>
      <div class="col-md-2">
        <!-- <mat-form-field appearance="outline">
                  <input matInput type="date" [(ngModel)]="model.fechaInicio" placeholder="dd/MM/yyyy" name="fechaInicio"/>
                </mat-form-field>    -->
        <mat-form-field appearance="outline">
          <mat-label>Fecha Inicio:</mat-label>
          <input
            matInput
            [ngModel]='model.fechaInicio | date: "dd/MM/yyyy"'
            disabled
          />
          <!-- [matDatepicker]="pckrFechaInicio"
            [ngModel]="model.fechaInicio" -->
          <!-- <mat-datepicker-toggle
            matSuffix
            [for]="pckrFechaInicio"
          ></mat-datepicker-toggle>
          <mat-datepicker #pckrFechaInicio></mat-datepicker> -->
        </mat-form-field>
      </div>
      <label class="col-md-1 control-label">Fecha Fin:</label>
      <div class="col-md-2">
        <!-- <mat-form-field appearance="outline">
                  <input matInput type="date" [(ngModel)]="model.fechaFin" placeholder="dd/MM/yyyy" name="fechaFin"/>
                </mat-form-field>    -->
        <mat-form-field appearance="outline">
          <mat-label>Fecha Fin</mat-label>
          <input
            matInput            
            [ngModel]='model.fechaFin | date: "dd/MM/yyyy"'
            disabled
          />
          <!-- [matDatepicker]="pckrFechaFin" -->
          <!-- <mat-datepicker-toggle
            matSuffix
            [for]="pckrFechaFin"
          ></mat-datepicker-toggle>
          <mat-datepicker #pckrFechaFin></mat-datepicker> -->
        </mat-form-field>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-1 control-label">OC:</label>
      <div class="col-md-2">
        <mat-form-field appearance="outline">
          <mat-label>Orden de compra</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="model.ordenCompra"
            name="ordenCompra"
            disabled
          />
        </mat-form-field>
      </div>
      <label class="col-md-1 col-md-offset-2 control-label">Notificar a:</label>
      <div class="col-md-3">
        <mat-form-field appearance="outline">
          <mat-label>Notificar a</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="model.notificarA"
            name="notificarA"
            disabled
          />
        </mat-form-field>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-1 control-label">Trabajo:</label>
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Trabajo</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="model.trabajo"
            name="trabajo"
            disabled
          />
        </mat-form-field>
      </div>
      <label class="col-md-1 control-label">Subcontratista:</label>
      <div class="col-md-5">
        <mat-form-field appearance="outline">
          <mat-label>Subcontratista</mat-label>
          <input matInput type="text" [(ngModel)]="model.subContratista" name="subContratista" disabled />
        </mat-form-field>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-1 control-label">Motivo:</label>
      <div class="col-md-10">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Motivo</mat-label>
          <textarea
            matInput
            placeholder="Motivo"
            [(ngModel)]="model.motivo"
            rows="5"
            name="motivo" [maxlength]="2000"
            disabled
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-1 control-label">Tipo de visita:</label>
      <div class="col-md-2">
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            [(ngModel)]="model.tipoVisita"
            disabled
          />
        </mat-form-field>
      </div>
    </div>
  </div>